export enum StatisticsType {
  GROSS_SALES = 'GROSS_SALES',
  NUMBER_OF_BOOKINGS = 'NUMBER_OF_BOOKINGS',
  REVENUES = 'REVENUES',
  NET_REVENUES = 'NET_REVENUES'
}

export const statisticsTypes = Object.values(StatisticsType);
